// Tarot Card AI-Generated Art for Major Arcana + CSS designs for Minor Arcana
// ONIMA mystical style — dark, gold, art nouveau

export const MAJOR_ARCANA_IMAGES = {
  0: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/2075847309d2705df816867bbcdccbfabbe6ef26c16e5d83c5ff1c92dfe770bb.png",
  1: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/dd3a78830296052c8afa3ea1e2f14bffafd416437856fee336464404805c74d0.png",
  2: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/c611ab27ace8d0256216db05cc0e213eff8dc909e0441443eb8ddac367bb67f7.png",
  3: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/f6074b70af9e400deef37d33a94243d258844ddb60a6b317431d93c408c65efd.png",
  4: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/42d5f816c94e9c10cf51a5ca5a1abbe8e6212800730f237a4d61b3b57617fb48.png",
  5: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/d420f4587bad2236890c605f978162166e5781d0f3fc829055f0c6924ed53d2e.png",
  6: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/6a2b3f836536bd04b3fdca941074bb6c67501f0f19bcd67e609303183dd2a835.png",
  7: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/a8da7e8cca0478986ac549db2d689209e4c6882f993997e09878b628178275ae.png",
  8: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/bdaf82777eb317d7f21bd14a32d479c97244b16c5f977b71784f474a44de8cef.png",
  9: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/9f15a3206123b05af35d802356f394e78559f74d76a9a0e516eeadf7115d2319.png",
  10: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/81306c68dafe6366444ef6c1414a382c22525606ac6974c2c781be852b5ee85f.png",
  11: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/f25e362dd408a3b381933f15789d2f0da26ea5ba6d3ef999b53a685d0813ff31.png",
  12: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/7c8f49a2e61aaf355bad388eeb4d1549b4237c357d182f8c43fe6d7c071b9396.png",
  13: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/f4538f2e361baf91ca3e290b6a12b7a0358ddac0a2bb075ed5e95278b238a969.png",
  14: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/9412e10066d51cd108a9e18dc5e3cc41cb2106f2ef22cbba1c7ef6d172316b3d.png",
  15: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/97dd76a886bd138a63c3fd139f9c3c4fa906ddc423bcf1e2eb84065f145b25df.png",
  16: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/1223494499d3f7545def2b06612e73f4a83c7e3f693ce04bfccc50302454b8b4.png",
  17: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/d8e9467239a410ab7ea002538029ea9aef16dc7fdb28c4db984c15672081f8b0.png",
  18: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/13aaab4e01590fc5200cc0099b0665e08f222275a24a5bc5e833fe7b1ed71efd.png",
  19: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/99551958cd00b4092fe704ce6e68aae9943fb5a11d1730584841395ac8996ea6.png",
  20: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/67508790050203cd94dce3d20a89d30b526c7fcfd00a4f84da9d12dcb5c95585.png",
  21: "https://static.prod-images.emergentagent.com/jobs/0f43bf51-48c1-4433-b523-32b68756be16/images/b90fda60f088610859cfcf271260725740aa28ceeee21e4e0f2db0f73913c468.png",
};

// Map Russian card names to Major Arcana numbers
export const CARD_NAME_TO_NUMBER = {
  "Шут": 0, "The Fool": 0,
  "Маг": 1, "The Magician": 1,
  "Верховная Жрица": 2, "The High Priestess": 2,
  "Императрица": 3, "The Empress": 3,
  "Император": 4, "The Emperor": 4,
  "Иерофант": 5, "The Hierophant": 5,
  "Влюблённые": 6, "The Lovers": 6,
  "Колесница": 7, "The Chariot": 7,
  "Сила": 8, "Strength": 8,
  "Отшельник": 9, "The Hermit": 9,
  "Колесо Фортуны": 10, "Wheel of Fortune": 10,
  "Справедливость": 11, "Justice": 11,
  "Повешенный": 12, "The Hanged Man": 12,
  "Смерть": 13, "Death": 13,
  "Умеренность": 14, "Temperance": 14,
  "Дьявол": 15, "The Devil": 15,
  "Башня": 16, "The Tower": 16,
  "Звезда": 17, "The Star": 17,
  "Луна": 18, "The Moon": 18,
  "Солнце": 19, "The Sun": 19,
  "Суд": 20, "Judgement": 20,
  "Мир": 21, "The World": 21,
};

// Minor Arcana suit symbols and colors
export const SUIT_STYLES = {
  "Жезлы": { symbol: "🔥", color: "#F59E0B", accent: "amber" },
  "Кубки": { symbol: "💧", color: "#3B82F6", accent: "blue" },
  "Мечи": { symbol: "⚔", color: "#8B5CF6", accent: "violet" },
  "Пентакли": { symbol: "⭐", color: "#D4AF37", accent: "yellow" },
  "Wands": { symbol: "🔥", color: "#F59E0B", accent: "amber" },
  "Cups": { symbol: "💧", color: "#3B82F6", accent: "blue" },
  "Swords": { symbol: "⚔", color: "#8B5CF6", accent: "violet" },
  "Pentacles": { symbol: "⭐", color: "#D4AF37", accent: "yellow" },
};

// Card back design
export const CARD_BACK_DESIGN = {
  pattern: `
    <pattern id="cardBack" width="20" height="20" patternUnits="userSpaceOnUse">
      <rect width="20" height="20" fill="#0a0b14"/>
      <circle cx="10" cy="10" r="1" fill="#D4AF37" opacity="0.3"/>
      <path d="M0 10 L20 10 M10 0 L10 20" stroke="#D4AF37" stroke-width="0.5" opacity="0.1"/>
    </pattern>
  `,
  centerSymbol: "✧"
};
